import React from 'react'
import { useNavigate } from 'react-router'
import AudioElement from '../AudioElement/AudioElement'

function Dance({ contestDetails, isPlaying, setIsplaying, audioElem, campaignClosed }) {
    const navigate = useNavigate()

    return (
        <>
            <div className='pt-[100px]'>
                {contestDetails?.contestPoster &&
                    <img src={contestDetails?.contestPoster} alt="" className={`h-[27vw] min-h-[167px] max-h-[290px] w-[100%] object-cover`} style={{ objectPosition: "0% 30%" }} />
                }
            </div>
            <div className="px-[16px] pt-[20px] flex flex-col">
                <span className="text-[28px] font-semibold ">
                    {contestDetails?.campaignName}
                </span>
                <span style={{ color: contestDetails?.buttonColor }} className=" text-[21px]">
                    {contestDetails?.contestName}
                </span>
                <div className="flex justify-between mt-[30px]">
                    <AudioElement contestDetails={contestDetails} isPlaying={isPlaying} setIsplaying={setIsplaying} audioElem={audioElem} />
                </div>
            </div>

            {!campaignClosed && <div className="h-[187px] w-[100%] bg-[#252525] flex flex-col justify-center items-center px-[30px] mt-[30px] text-center">
                <span className="text-[21px] opacity-[80%] font-semibold">
                    {contestDetails?.entryFee?.heading}
                </span>
                <span className="text-[17px] font-semibold">
                    {contestDetails?.entryFee?.fee}
                </span>
                <span className="text-[px] text-[#BDBDBD]">
                    {contestDetails?.entryFee?.description}
                </span>
                <span style={{ color: contestDetails?.buttonColor }} className="text-[px] font-semibold hover:cursor-pointer" onClick={() => { navigate("/payment") }}>
                    {contestDetails?.entryFee?.linkText}
                </span>
            </div>}
            <div className="px-[16px] flex flex-col">
                <div className="flex justify-around mt-[20px]">
                    <div className="w-[110px] h-[136px] bg-[#171717] flex flex-col justify-around p-[15px] rounded-[8px]">
                        <span className="opacity-[0.6] text-[14px]">
                            1<sup>st</sup> Prize
                        </span>
                        <span className="text-[18px] font-semibold">
                            ₹ {contestDetails?.prize?.firstPrize}
                        </span>
                        <span className="opacity-[0.6] text-[14px]">Cash Price</span>
                    </div>
                    <div className="w-[110px] h-[136px] bg-[#171717] flex flex-col justify-around p-[15px] rounded-[8px]">
                        <span className="opacity-[0.6] text-[14px]">
                            2<sup>nd</sup> Prize
                        </span>
                        <span className="text-[18px] font-semibold">
                            ₹ {contestDetails?.prize?.secondPrize}
                        </span>
                        <span className="opacity-[0.6] text-[14px]">Cash Price</span>
                    </div>
                    <div className="w-[110px] h-[136px] bg-[#171717] flex flex-col justify-around p-[15px] rounded-[8px]">
                        <span className="opacity-[0.6] text-[14px]">
                            3<sup>rd</sup> Prize
                        </span>
                        <span className="text-[18px] font-semibold">
                            ₹ {contestDetails?.prize?.thirdPrize}
                        </span>
                        <span className="opacity-[0.6] text-[14px]">Cash Price</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dance